import { render, staticRenderFns } from "./Chat.Message.vue?vue&type=template&id=a84cfafc&"
import script from "TY/components/chat/chat.component.roomMessage.js?vue&type=script&lang=js&"
export * from "TY/components/chat/chat.component.roomMessage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports